import script from "./Toolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Toolbar.vue?vue&type=script&setup=true&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=5ebfa5cc&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ebfa5cc"]])

export default __exports__